import { Grid } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import CheckoutArea from 'src/checkout-area/checkout-area';
import { PageStatus, setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { calculateWidth } from 'src/common/helpers/dimension-helper';
import { AppState } from 'src/common/redux/configure-store';
import { getScannerCallback } from 'src/devices/scanner-operations';
import SizedGridItem from 'src/sized-grid-item/sized-grid-item';
import TenderingView from 'src/tendering/tendering-view';
import { styles } from './home-page-tendering-styles';
import { useResponsiveContext } from 'src/home-page/hooks/responsive-context';

export const TenderingModeHomePage = 'TenderingModeHomePage';

// TODO: Instead of re-setting the home page, would it be better to just replace the middleArea only?
const HomePageTendering: React.FC = (): JSX.Element => {
  const isLeftHanded = useSelector<AppState, boolean>(state => state.cashierPreferences.leftHanded);
  const classes = styles({ leftHanded: isLeftHanded });
  const { showSidebar } = useResponsiveContext();
  let checkoutWidth: string;
  if (!showSidebar) {
    checkoutWidth = calculateWidth(304, 1024).stringValue;
  } else {
    checkoutWidth = calculateWidth(355).stringValue;
  }

  return (
    <Grid container wrap='nowrap' direction={isLeftHanded ? 'row-reverse' : 'row'}>
      <SizedGridItem
        size={checkoutWidth}
        className={`fullHeight ${
          !showSidebar ? classes.itemListContainerSmallForm : classes.itemListContainer
        }`}
      >
        <CheckoutArea />
      </SizedGridItem>

      <Grid item className={`fullHeight flexFull ${classes.middleArea}`}>
        <Grid container direction='column' className={`fullHeight fullWidth`}>
          <SizedGridItem size='auto' className={`fullWidth fullHeight`}>
            <TenderingView />
          </SizedGridItem>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HomePageTendering;

export const setHomePageTendering = (): void => {
  const buttonStatus: PageStatus = {
    enableSidebar: true,
    enableSearch: true,
    enablePluMenu: true,
    enableCheckoutButton: true,
    pageId: TenderingModeHomePage,
  };
  setHomePage(<HomePageTendering />, getScannerCallback(), buttonStatus);
};
